import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    appList: [],
    tentIdlist: [],
    pagination: {
      page: 1,
      size: 10
    },
    androidInfo: '',
    h5Info:'',
    iosInfo: '',
    plistInfo: '',
    editingPlatform: null,
    editingUrl: '',
    totalCount:0
  },
  mutations: {
    setAppInfo(state, payload) {
      console.log('state-info',payload);
      state[
        payload.platform === 'android'
          ? 'androidInfo'
          : payload.platform === 'h5'
            ? 'h5Info'
            : payload.platform === 'ios_appstore'
              ? 'iosInfo'
              : 'plistInfo'
          
      ] = payload.data;
    },
    setEditingPlatform(state, platform) {
      state.editingPlatform = platform;
    },
    setEditingUrl(state, url) {
      state.editingUrl = url;
    },
    setTentIdlist(state, payload) {
      state.tentIdlist = payload;
    },
    setAppList(state, payload) {
      state.appList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setpage(state, page) {
      state.pagination = page;
    },
  },
  actions: {
    getAppList({commit},data){
    return  api.getAppList(data).then(res=>{
      console.log('resddddddd',res);
      commit('setAppList',res.data)
        return res
      })
    },
    addApp({commit},data){
    return  api.addApp(data).then(res=>{
      console.log('res-aaaaaaa',res);
        return res
      })
    },
    changeStatusApp({commit},data){
    return  api.changeStatusApp(data).then(res=>{
        return res
      })
    },
    handleSaveInfo({commit},data){
    return  api.handleSaveInfo(data).then(res=>{
        return res
      })
    },
    getTentIdlist({commit}){
     return api.getTentIdlist().then(res=>{
        commit('setTentIdlist',res.data)
        return res
      })
    },
    info({ commit }, platform) {
      api.getAppInfo(platform).then(({ data }) => {
        commit('setAppInfo', { platform, data });
      });
    },
    saveInfo(context, params) {
      return api.saveAppInfo(params);
    },
    saveVersionAppInfo(context, params) {
      return api.saveVersionAppInfo(params);
    },
    getVersionAppInfo(context, platform) {
      return api.getVersionAppInfo(platform);
    }
  }
};

appStore.registerModule('app', store);
